import SetupBaseController from '../common/setup.base.controller';
import PrefixTableController from '../common/prefix-table/prefix-table.controller';
import AppConstants from '../../../../../config/app.constants';

class SetupCreateController extends SetupBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, SetupService, Modal, DateUtil, $translate, $stateParams, BranchService, VaultService, $q, LocationService, RouteService, $timeout, CurrencyService, UsersService, WindowService) {
    super(Auth, $state, User, SetupService, Modal, $translate, $stateParams);
    this.BranchService = BranchService;
    this.VaultService = VaultService;
    this.LocationService = LocationService;
    this.RouteService = RouteService;
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.CurrencyService = CurrencyService;
    this.UsersService = UsersService;
    this.WindowService = WindowService;
    this.$q = $q;
    this.$timeout = $timeout;
    this.hasACL = {};
    this.errors = {};
    this.loadPrefixDirective = false;

    this.defaultModel = {
      description: '',
      address: '',
      city: '',
      state: null,
      zip: '',
      telno: '',
      exitPassword: '',
      confirmExitPassword: '',
      dataToServer: '',
      dataFromServer: '',
      toHHTProtocol: null,
      fromHHTProtocol: null,
      transmitMsgFiles: false,
      verify: true,
      keyVerify: true,
      showCoinTotal: true,
      noPrintDelivery: false,
      noPrintPickup: false,
      coinCheckIn: false,
      coinCheckOut: false,
      currentVaultDate: null,
      reqMessengerStopScan: false,
      atLocationScan: true,
      maxItemsPerBagout: null,
      branchId: null,
      vaultId: null,
      // startAt: null,
      // max: null,
      defaultLanguageId: null,
      requireDriver: true,
      requireGuard: false,
      useHolidayRoutes: false,
      allowBulkHoldVerify: false,
      locationRequiresCustomer: false,
      packingRequired: false,
      prefixes: [],
      currency: null,
      branch: this.$stateParams.branch || this.User.getUser().branchId,
      limitPerATMDeposit: null,
      fromLocationId: null,
      tankerId: null,
      virtualTankerId: null,
      holdRouteId: null,
      defaultSupervisorId: null,
      supervisorScan: true,
      unassignedRouteId: null,
      enableGeoCoding: false,
      packCharLength: null,
      timezone: null,
      gpsLat: 0.0,
      gpsLong: 0.0,
      limitPerRoute: null,
      // limitPerEventRoute: null
      serviceTickets: true,
      ATMTransfer: false,
      bagoutFromCompany: '',
      autoDeleteBagouts: false,
      deletePickups: false,
      pickupIdLength: false,
      charactersRequired: 0,
      bypassLocation: false,
      bypassItem: false,
      bypassDelivery: false,
      bypassPickup: false,
      editPickupId: false,
      OTCCencon: false,
      OTCLMS: false,
      OTCTDS: false,
      OTCCenconCheckoutMode: null,
      OTCCenconRouteMode: null,
      OTCCenconServiceMode: null,
      OTCLMSCheckoutDur: null,
      OTCLMSRouteDur: null,
      OTCLMSServiceDur: null,
      ignorePackRequirement: false,
      billingEnabled: false,
      addBagToCheckout: false,
      vaultLiability: '',
      alertThreshold: null,
      alertRecipientEmail: '',
      printPackLabel: false,
      printPrePack: true,
      verifyPickupUnique: false,
      notDeliveredResolution: false,
      defaultToTankerId: null,
      defaultFromTankerId: null,
      defaultWindowId: null,
      enableAutoCheckInCheckOut: false,
      enableAutoSubmit: false,
      additionalPickup: false,
      serviceOrderTruckScan: false,
      bagoutBranchId: null,
      isNonUSLocation: false,
      loadTruck: false,
      checkInTanker: false,
      bypassCantCloseATM: false,
      requireSignatureName: false,
      enforceStrongPassword: false,
      minimumPasswordLength: null,
      lowercaseCharacterLength: null,
      uppercaseCharacterLength: null,
      numericCharacterLength: null,
      specialCharacterLength: null,
      forceChangePasswordDays: null,
      cantScanLocation: false,
      loadBreakdown: false,
      packSlip: false,
      cantScanTruck: false,
      cantScanBag: false,
      routeNFC: false,
      truckNFC: false,
      cantScanNFC: false,
      autoAssignServiceTicket: false,
      disableCopyPaste: false,
      disableTrackingIdTyping: false,
      assignServiceZone: false,
      serviceLocationTypes: ['ATM'],
      unassignOnVaultClose: false,
      serviceChecklist: false,
      checkoutTruckLiability: false,
      autoGenerateTrackingId: false,
      trackingIdPrefix: '',
      trackingIdNumber: null,
      cancelSupervisorChallenge: false,
      unassignOnDayClose: false,
      autoCloseVault: false,
      convertToPickup: false,
      availableCurrencyIds: [],
      currencyId: null,
      // multiDayRoutes: false
      undeliveredAnytimeFlag:false,
      branchCounters: [],
      virtualTankers:false,
      autoDetectScannerCode: true,
      barcodeType: null,
      enforceChecksum: false,
      locationOnHold: false,
      checksumDigits: null,
    };

    this.states = [
      "Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado",
      "Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia",
      "Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
      "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts",
      "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
      "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
      "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico",
      "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
      "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ];

    // this.timezoneList = [
    //   { label: 'EST', value: 'EST' },
    //   { label: 'EDT', value: 'EDT' },
    //   { label: 'CST', value: 'CST' },
    //   { label: 'CDT', value: 'CDT' },
    //   { label: 'MST', value: 'MST' },
    //   { label: 'MDT', value: 'MDT' },
    //   { label: 'PST', value: 'PST' },
    //   { label: 'PDT', value: 'PDT' },
    //   { label: 'EST5EDT', value: 'EST5EDT' }
    // ];

    this.locationLists = [];
    this.tankerList = [];
    this.holdRouteList = [];
    this.unassignedRoutes = [];
    this.virtualTankerList = [];

    this.HHTProtocolValues = [
      { label: 'W', value: 'W' },
      { label: 'D', value: 'D' }
    ];
    this.languages = [
      { value: 'E', label: "English" },
      // { value: 'F', label: 'French' }
      { value: 'S', label: 'Spanish' }
    ];

    this.defaultServiceTicketAssignment = [
      { value: 'ROUTE', label: 'Route' },
      { value: 'USER', label: 'User' },
      { value: 'EXTERNAL', label: 'External' }
    ];
    this.serviceLocationTypeOptions = [
      { name: 'ATM', label: 'ATM' },
      { name: 'REGULAR', label: 'Regular' },
      { name: 'BANK', label: 'Bank' },
      { name: 'ON_CALL', label: 'On Call' },
      { name: 'NO_SHIP_NO_GO', label: 'No Ship No Go' }
    ];
    this.model = angular.copy(this.defaultModel)
    this.syncServiceLocationTypes = () => {
      if (!Array.isArray(this.model.serviceLocationTypes) || !this.model.serviceLocationTypes.length) {
        this.model.serviceLocationTypes = ['ATM'];
      }
      this.serviceLocationTypeOptions.forEach((option) => {
        option.ticked = this.model.serviceLocationTypes.includes(option.name);
      });
      this.selectedServiceLocationTypes = this.serviceLocationTypeOptions.filter((option) => option.ticked);
    };
    this.syncServiceLocationTypes();
    this.updateServiceLocationTypes = () => {
      this.selectedServiceLocationTypes = this.serviceLocationTypeOptions.filter((option) => option.ticked);
      this.model.serviceLocationTypes = this.selectedServiceLocationTypes.map((option) => option.name);
    };
    this.selectNoneServiceLocationTypes = () => {
      this.$timeout(() => {
        const atmOption = this.serviceLocationTypeOptions.find((option) => option.name === 'ATM');
        this.serviceLocationTypeOptions.forEach((option) => {
          option.ticked = option === atmOption;
        });
        this.selectedServiceLocationTypes = [atmOption];
        this.model.serviceLocationTypes = ['ATM'];
      });
    };

    this.branches = [];
    this.vaults = [];
    this.valutDate = "";
    this.currencys = [];
    this.currencyOptions = [];
    this.supervisors = [];
    this.passWdIcon = {
      exitPassword: false,
      confirmExitPassword: false
    }

    this.cenconLockOptions = [
      { label: 'RTE Mode', value: 'RTE' },
      { label: 'FLM Mode', value: 'FLM' }
    ];

    this.LMSLockOptions = [
      { label: 'Next Available', value: 'NA' },
      { label: '4 Hours', value: '4' },
      { label: '8 Hours', value: '8' },
      { label: '12 Hours', value: '12' },
      { label: 'Midnight', value: 'MN' }
    ];  

    this.barCodeTypes = [
      { label: 'CODE_128', value: 'CODE_128' },
      { label: 'CODE_39', value: 'CODE_39' },
      { label: 'CODABAR', value: 'CODABAR' },
      { label: 'DATA_MATRIX', value: 'DATA_MATRIX' },
      { label: 'EAN_13', value: 'EAN_13' },
      { label: 'EAN_8', value: 'EAN_8' },
      { label: 'ITF', value: 'ITF' },
      { label: 'QR_CODE', value: 'QR_CODE' },
      { label: 'UPC_A', value: 'UPC_A' },
      { label: 'UPC_E', value: 'UPC_E' },
      { label: 'PDF417', value: 'PDF417' },
      { label: 'AZTEC', value: 'AZTEC' }
    ];

    this.fromTankerObj = {
      results: [],
      totalRecords: 0
    };

    this.toTankerObj = {
      results: [],
      totalRecords: 0
    };

    this.windowObj = {
      results: [],
      totalRecords: 0
    };

    this.branchCost = [];
    this.counters = [{name: '', serialNumber: ''}];
    this.timezoneList = [];
  }

  $onInit() {
    this.isDuplicateBranchCost = true;
    this.isValidDistance = false;

    this.$q.all([
      this.BranchService.all(null, 0, 1000),
      this.VaultService.all(null, 0, 1000),
      this.Service.all(null, 0, 1000),
      this.SetupService.get(this.model.branch),
      this.CurrencyService.all(null, 0, AppConstants.defaultPageSize),
      this.getBranchSupervisors()
    ])
      .then((data) => {
        const date = this.DateUtil.getUTCDate(data[3].currentVaultDate || undefined);
        this.valutDate = moment(date).format('YYYY-MM-DD');
        this.model = this.defaultModel;
        this.syncServiceLocationTypes();
        this.model.currentVaultDate = moment(this.valutDate).toDate()

        this.dates = this.DateUtil.getUTCDate(data[3].currentVaultDate || undefined);
        const branchesWithExistingSetupRecord = data[2].results.map((setupRecord) => {
          return setupRecord.branchId;
        });

        this.branches = data[0].results
          .filter((branch) => !branchesWithExistingSetupRecord.includes(branch.id))
          .map((branch) => branch.id);

        this.currencys = data[4].results.map((currency) => currency.id);
        this.vaults = data[1].results.map((vault) => vault.id);
        this.loadPrefixDirective = true;
        this.loadBranchData()
        this.momentTimeZone();
        this.prefixes = Object.assign({ messenger: ["D"] }, this.model.prefixes);

        // Then create currencyOptions with correct ticked values
        this.currencyOptions = data[4].results.map((currency) => ({
          id: currency.id,
          ticked: this.model.availableCurrencyIds && this.model.availableCurrencyIds.includes(currency.id)
        }));
      });
  }

  momentTimeZone() {
    const timezone = this.mappingTimezone();
    this.timezoneList = this.timezoneList.concat(timezone);
    this.totalTimezones = this.timezoneList.length;
  }

  mappingTimezone() {
    return moment.tz.names().map((item) => {
      return { Key: item, Value: item }
    });
  }

  prioritizeTimezone(timezone) {
    if(!timezone) return;

    const existingIndex = this.timezoneList.findIndex(item => item.Value === timezone);

    if (existingIndex > -1) {
      this.timezoneList.splice(existingIndex, 1);
    }

    this.model.timezone = {
      Key: timezone,
      Value: timezone
    };

    this.timezoneList.unshift(this.model.timezone);
    this.totalTimezones = this.timezoneList.length;
  }

  reset() {
    this.loadPrefixDirective = false;
    this.$onInit()
    this.model = angular.copy(this.defaultModel)
    this.syncServiceLocationTypes();
    this.branchCost = [];
    this.counters = [{name: '', serialNumber: ''}];
    this.model.availableCurrencyIds = [];
    this.model.currencyId = null
  }

  searchSupervisorQuery() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: "supervisor",
            condition: "=",
            data: true
          }
        ],
        operator: "AND"
      }
    }
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  getBranchSupervisors() {
    this.Service.supervisorList(this.model.branchId)
      .then((data) => {
        this.supervisors = data.results;
      })
      .catch(err => {
        console.log(err);
      })
  }

  submit(evt) {
    // if (!this.validate()) {
    // 	return
    // }
    this.errors = {};
    this.loading = true;
    const DEFAULT_MAX_ITEMS_PER_BAGOUT = 40,
      DEFAULT_MAX_PACK_CHAR_LENGTH = 0;

    this.model.maxItemsPerBagout = this.model.maxItemsPerBagout || DEFAULT_MAX_ITEMS_PER_BAGOUT;
    this.model.packCharLength = this.model.packCharLength || DEFAULT_MAX_PACK_CHAR_LENGTH;

    if (this.model.exitPassword !== this.model.confirmExitPassword) {
      this.loading = false;
      this.errors['password'] = this.$translate.instant('setup.exitPasswordMismatch')
      return;
    }

    if (this.model.defaultFromTankerId && this.model.defaultToTankerId && this.model.defaultFromTankerId.Value === this.model.defaultToTankerId.Value) {
      this.loading = false;
      this.Modal.errorModal(this.$translate.instant('setup.tanker_error'));
      return;
    }

    if (!this.validateCounters()) {
      this.loading = false;
      return;
    }

    const branchCost = [];
    this.branchCost.forEach((bc) => {
        bc.name = bc.name;
        bc.startDistance = bc.startDistance;
        bc.endDistance = bc.endDistance;
        bc.standardLoad = bc.standardLoad;
        bc.ecLoad = bc.ecLoad;
        bc.setupId = bc.setupId;
        bc.branchId = bc.branchId;
        bc.createdByUserId = bc.createdByUserId;
        bc.modifiedByUserId = bc.modifiedByUserId;
        delete bc.isDuplicate;
        delete bc.isValid;
        branchCost.push(_.cloneDeep(bc));
    });

    this.model.currentVaultDate = moment(this.model.currentVaultDate).format('YYYY-MM-DD')
    this.model.fromLocationId = this.model.fromLocationId.Value;
    this.model.tankerId = this.model.tankerId ? this.model.tankerId.Value : null;
    this.model.virtualTankerId = this.model.virtualTankerId ? this.model.virtualTankerId.Value : null;
    this.model.holdRouteId = this.model.holdRouteId ? this.model.holdRouteId.Value : null;
    this.model.limitPerATMDeposit = this.model.limitPerATMDeposit ? this.model.limitPerATMDeposit : null
    this.model.defaultSupervisorId = this.model.defaultSupervisorId.id ? this.model.defaultSupervisorId.id : null
    this.model.unassignedRouteId = this.model.unassignedRouteId ? this.model.unassignedRouteId.Value : null;
    this.model.gpsLat = this.model.gpsLat ? parseFloat(this.model.gpsLat) : 0.0;
    this.model.gpsLong = this.model.gpsLong ? parseFloat(this.model.gpsLong) : 0.0;
    this.model.limitPerRoute = this.model.limitPerRoute ? this.model.limitPerRoute : null;
    this.model.alertThreshold = this.model.alertThreshold ? this.convertStr(this.model.alertThreshold) : null;
    this.model.defaultWindowId = this.model.defaultWindowId ? this.model.defaultWindowId.Value : null;
    this.model.defaultFromTankerId = this.model.defaultFromTankerId ? this.model.defaultFromTankerId.Value : null;
    this.model.defaultToTankerId = this.model.defaultToTankerId ? this.model.defaultToTankerId.Value : null;
    this.model.country = this.model.isNonUSLocation ? this.model.country : 'US',
    this.model.charactersRequired = this.model.pickupIdLength ? this.model.charactersRequired : 0;
    this.model.barcodeType = !this.model.autoDetectScannerCode ? this.model.barcodeType : null;
    this.model.checksumDigits = this.model.enforceChecksum ? this.model.checksumDigits : null;
    this.model.timezone = this.model.timezone ? this.model.timezone.Value : null;
    this.model.locationOnHold = this.model.locationOnHold ? this.model.locationOnHold : null;
    this.model.serviceLocationTypes = this.selectedServiceLocationTypes.map((option) => option.name);
    const validCounters = this.counters.filter(c => {
      const name = (c.name || '').trim();
      const serial = (c.serialNumber || '').trim();
      return name && serial;
    });
    this.model.branchCounters = validCounters;
    
    this.model.branchCost = branchCost;
    this.model.userId =  this.User.getUser().id;
    
    const payload = {...this.model};
    payload.availableCurrencyIds = Array.isArray(this.model.availableCurrencyIds)
      ? this.model.availableCurrencyIds.map((o)=>o.id)
      : [];
    this.Service.create(payload)
      .then((data) => {
        this.askCreate();
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  loadBranchData() {
    this.getAllLocation();
    this.loadTanker();
    // this.loadRoutes();
    this.loadUnassignedRoutes();
    this.loadHoldRoutes();
    this.loadVirtual();
    this.getBranchWindow('', 0);
    this.loadFromTanker('', 0);
    this.loadToTanker('', 0);
    this.getBranchSupervisors();
    this.model.fromLocationId = '';
    this.model.tankerId = '';
    this.model.holdRouteId = '';
    this.model.virtualTankerId = '';
  }

  getAllLocation(searchKey, offset) {
    searchKey = searchKey || '';
    const searchObj = {
      queryJSON: {
        rules: [{
          field: 'branchId',
          condition: '=',
          data: this.model.branchId
        },
        {
          field: 'locationType',
          condition: '=',
          data: 'INTERNAL'
        },
        {
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + searchKey + '%'
            },
            {
              field: 'name',
              condition: 'like',
              data: '%' + searchKey + '%'
            }
            ],
            operator: 'OR'
          }
        }
        ],
        operator: 'AND'
      },
    }

    this.LocationService.getAllLocation(searchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalLocatin = data.total;
          this.locationLists = this.mapData(data.results);
        } else {
          const locations = this.mapData(data.results);
          this.locationLists = this.locationLists.concat(locations);
        }
      })
  }

  getRoutes(searchKey, offset) {
    searchKey = searchKey || '';
    const routeSearchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };

    const routeDefer = this.$q.defer();
    this.RouteService.all(routeSearchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        routeDefer.resolve(data);
        // this.model.holdRouteId = null;
        // this.routes = data.results;

        // if (offset === 0 || offset == undefined) {
        //   this.totalHoldRoutes = data.total;
        //   this.totalUnassignedRoutes = data.total;
        //   this.holdRouteList = this.mapData(data.results);
        //   this.unassignedRoutes = this.mapData(data.results);
        // } else {
        //   const routes = this.mapData(data.results);
        //   this.holdRouteList = this.holdRouteList.concat(routes);
        //   this.unassignedRoutes = this.unassignedRoutes.concat(routes);
        // }
      })
      .catch((err) => {
        routeDefer.reject(err);
      })
    return routeDefer.promise;
  }

  loadHoldRoutes(searchKey, offset) {
    this.getRoutes(searchKey, offset)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalHoldRoutes = data.total;
          this.holdRouteList = this.mapData(data.results);
        } else {
          const routes = this.mapData(data.results);
          this.holdRouteList = this.holdRouteList.concat(routes);
        }
      })
  }

  loadUnassignedRoutes(searchKey, offset) {
    this.getRoutes(searchKey, offset)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.totalUnassignedRoutes = data.total;
          this.unassignedRoutes = this.mapData(data.results);
        } else {
          const routes = this.mapData(data.results);
          this.unassignedRoutes = this.unassignedRoutes.concat(routes);
        }
      })
  }

  // get tanker data
  loadVirtual(searchKey, offset) {
    this.getTanker(searchKey, offset).then(virtualData => {
      if (offset === 0 || offset == undefined) {
        this.totalVtanker = virtualData.total;
        this.virtualTankerList = this.mapData(virtualData.results);
      } else {
        const tankers = this.mapData(virtualData.results);
        this.virtualTankerList = this.virtualTankerList.concat(tankers);
      }
    })
  }

  loadTanker(searchKey, offset) {
    this.getTanker(searchKey, offset)
      .then(tankerData => {
        if (offset === 0 || offset == undefined) {
          this.totaltanker = tankerData.total;
          this.tankerList = this.mapData(tankerData.results);
        } else {
          const tankers = this.mapData(tankerData.results);
          this.tankerList = this.tankerList.concat(tankers);
        }
      })
  }

  getTanker(searchKey, offset) {
    searchKey = searchKey || '';
    const tankerSearchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          },
          {
            field: 'locationType',
            condition: '=',
            data: 'TANKER'
          },
          {
            field: 'active',
            condition: '=',
            data: true
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: "AND"
      }
    };
    let deferred = this.$q.defer();
    this.LocationService.getAllLocation(tankerSearchObj, offset, AppConstants.defaultPageLimit)
      .then((tankerData) => {
        // this.model.tankerId = null;
        // this.model.virtualTankerId = null;
        // this.tankers = tankerData.results;
        deferred.resolve(tankerData)
      }).catch(e => deferred.reject(e));
    return deferred.promise;
  }

  mapData(mapArray) {
    return mapArray.map((obj) => {
      return {
        Key: obj.id + " | " + obj.name,
        Value: obj.id
      }
    });
  }

  showPassword(type) {
    this.passWdIcon[type] = !this.passWdIcon[type];
  }

  ngPercentage() {
    if (this.model.alertThreshold && !this.model.alertThreshold.endsWith('%')) {
      return this.model.alertThreshold = this.model.alertThreshold + '%';
    }
  }

  convertStr(str) {
    if (!str) return;
    return Number(str.replace('%', ''));
  }

  removePrecentageSign() {
    if (this.model.alertThreshold && this.model.alertThreshold.endsWith('%')) {
      return this.model.alertThreshold = this.model.alertThreshold.replace('%', '');
    }
  }

  onPrintPack() {
    // this.model.printPrePack = !this.model.printPackLabel;
    if (this.model.printPackLabel && !this.model.printPrePack) {
      this.model.printPrePack = true;
    }
    else this.model.printPackLabel = this.model.printPackLabel;
  }

  onPrePrintPack() {
    // this.model.printPackLabel = !this.model.printPrePack;
    if (this.model.printPrePack && !this.model.printPackLabel) {
      this.model.printPackLabel = true;
    }
    else this.model.printPrePack = this.model.printPrePack;
  }

  getBranchWindow(searchKey, offset) {
    searchKey = searchKey || '';

    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branchId
          },
          {
            field: 'locationType',
            condition: '=',
            data: 'WINDOW'
          },
          {
            field: 'active',
            condition: '=',
            data: true
          },
          {
            group: {
              rules: [{
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'name',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }],
        operator: 'AND'
      }
    };

    return this.LocationService.getAllLocation(searchObj, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.windowObj.results = this.mapData(data.results);
          this.windowObj.totalRecords = data.total;
        } else {
          const locations = this.mapData(data.results);
          this.windowObj.results = this.windowObj.results.concat(locations);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  loadFromTanker(searchKey, offset) {
    this.getTanker(searchKey, offset)
      .then(data => {
        if (offset === 0 || offset == undefined) {
          this.fromTankerObj.results = this.mapData(data.results);
          this.fromTankerObj.totalRecords = data.total;
        } else {
          const tankers = this.mapData(data.results);
          this.fromTankerObj.results = this.fromTankerObj.results.concat(tankers);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  loadToTanker(searchKey, offset) {
    this.getTanker(searchKey, offset)
      .then(data => {
        if (offset === 0 || offset == undefined) {
          this.toTankerObj.results = this.mapData(data.results);
          this.toTankerObj.totalRecords = data.total;
        } else {
          const tankers = this.mapData(data.results);
          this.toTankerObj.results = this.toTankerObj.results.concat(tankers);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  resetText() {
		this.model.state = null;
		this.model.country = null;
	}

  addNewCost(event) {
    this.branchCost.push({
      name: null,
      startDistance: null,
      endDistance: null,
      standardLoad: null,
      ecLoad: null,
      setupId: null,
      branchId: this.model.branchId,
      createdByUserId: this.User.getUser().id,
      modifiedByUserId: this.User.getUser().id,
    })
    event.preventDefault();
  }

  removeCost(index) {
    this.branchCost.splice(index, 1);
    this.validateDistance()
    this.validateBranchCost()
  }

  validateDistance() {
    this.branchCost.forEach(bc => bc.isValid = false);

    for (let i = 0; i < this.branchCost.length; i++) {
      const currentCost = this.branchCost[i];
      const startDistance = parseFloat(currentCost.startDistance);
      const endDistance = parseFloat(currentCost.endDistance);

      currentCost.isValid = startDistance >= endDistance;
    }
    this.isValidDistance = this.branchCost.some(bc => bc.isValid);
  }

  validateBranchCost() {
    this.branchCost = _.map(this.branchCost, (mainObj, mainObjIndex) => {
      mainObj.isDuplicate = false;
      let eq = _.find(this.branchCost, (compairObject, compairObjIndex) => {
        if (mainObjIndex > compairObjIndex) {
          return (compairObject.startDistance === mainObj.startDistance && compairObject.endDistance === mainObj.endDistance) ;
        }
      });
      if (eq) {
        mainObj.isDuplicate = true;
        return mainObj;
      } else {
        return mainObj;
      }
    });

    let isValid = this.branchCost.map((obj) => {
      if (obj.isDuplicate) return true;
    })

    this.isDuplicateBranchCost = isValid.indexOf(true) >= 0 ? false : true
  }

  isAllDataFilled() {
    return this.branchCost.every(bc => {
      return bc.name && (bc.startDistance !== null && bc.startDistance !== undefined && bc.startDistance !== "") &&
        (bc.endDistance !== null && bc.endDistance !== undefined && bc.endDistance !== "") &&
        (bc.standardLoad !== null && bc.standardLoad !== undefined && bc.standardLoad !== "") &&
        (bc.ecLoad !== null && bc.ecLoad !== undefined && bc.ecLoad !== "");
    })
  }

  addCounter() {
    this.counters.push({
      name: '',
      serialNumber: ''
    });
  }

  removeCounter(index) {
    this.counters.splice(index, 1);
  }

  checkDuplicateSerials() {
    this.counters = this.counters || [];
    const serialSet = new Set();
    
    for (const c of this.counters) {
      const name = (c.name || '').trim();
      const serial = (c.serialNumber || '').trim();
      
      if (name && serial) {
        const serialLower = serial.toLowerCase();
        if (serialSet.has(serialLower)) {
          return true;
        }
        serialSet.add(serialLower);
      }
    }
    
    return false;
  }

  validateCounters() {
    if (this.checkDuplicateSerials()) {
      this.Modal.errorModal(this.$translate.instant('setup.duplicateSerial'));
      return false;
    }
    return true;
  }

  onAvailableCurrenciesChange() {
    if (this.model.availableCurrencyIds.length === 1) {
      this.model.currencyId = this.model.availableCurrencyIds[0].id;
      return;
    }
  
    const currentCurrencyExists = this.model.availableCurrencyIds.some(curr => curr.id === this.model.currencyId);
    if (!currentCurrencyExists) {
      this.model.currencyId = this.model.availableCurrencyIds[0].id;
    }
  }
  setPrimaryCurrency = function(currencyId) {
    this.model.currencyId = currencyId;
  };
  
}

export default SetupCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/create/setup.create.controller.js